import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/es';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { getIpbPackageByChannelAction } from '_models/redux/ipb-package-by-channel/action';
import { cleanIpbPackageByChannelAction } from '_models/redux/ipb-package-by-channel/clean-action';
import PackageSalesCharts from './components/PackageSalesCharts';
import LeadsByCampaingFilters from '../filters/filters';
import { LoadersContext } from '_models/context/app';

const PackageIpbByChannelPage = (props) => {
  const loadersContext = useContext(LoadersContext);
  const { setIsScreenLoading } = loadersContext || {};
  const [errorMessage, setErrorMessage] = useState(null);
  const { getIpbPackageByChannelAction, cleanIpbPackageByChannelAction, ipbPackageByChannel } =
    props || {};

  const {
    watch,
    reset,
    control,
    setValue,
    getValues,
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  const [filters, setFilters] = useState({});

  const [fromTime, setFromTime] = useState(moment().startOf('month').format());
  const [toTime, setToTime] = useState(moment().format());

  const [displayDatepickers, setDisplayDatepickers] = useState('displayDatepickers hidden');

  useEffect(() => {
    return () => {
      setIsScreenLoading(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const formattedFromDate = moment(fromTime).format('YYYY-MM-DD');
    const formattedToDate = moment(toTime).format('YYYY-MM-DD');

    setFromTime(formattedFromDate);
    setToTime(formattedToDate);
  }, [fromTime, toTime]);

  const getLoadedMethods = () => {
    getIpbPackageByChannelMethod();
  };

  const getIpbPackageByChannelMethod = () => {
    if (!fromTime && !toTime) {
      setErrorMessage('Debes ingresar al menos una fecha.');
      return;
    }

    if (
      (fromTime && moment(fromTime).isAfter(moment())) ||
      (toTime && moment(toTime).isAfter(moment()))
    ) {
      setErrorMessage('No debes ingresar fechas futuras.');
      return;
    }

    if (fromTime && toTime && moment(fromTime).isAfter(moment(toTime))) {
      setErrorMessage("La fecha 'Desde' no puede ser mayor que la fecha 'Hasta'.");
      return;
    }

    if (fromTime && toTime && moment(toTime).diff(moment(fromTime), 'days') > 31) {
      setErrorMessage('La diferencia entre las fechas no puede ser mayor a 31 días.');
      return;
    }

    setErrorMessage(null);
    getIpbPackageByChannelAction({
      from_time: fromTime,
      to_time: toTime,
    });
  };

  const loadData = () => {
    if (fromTime && toTime) {
      setIsScreenLoading(true);
      getLoadedMethods();
      setIsScreenLoading(false);
    }
  };

  const parentProperties = {
    form: {
      watch,
      reset,
      control,
      setValue,
      getValues,
      register,
      handleSubmit,
      setError,
      errors,
    },
    redux: {
      getIpbPackageByChannelAction,
      cleanIpbPackageByChannelAction,
      ipbPackageByChannel,
    },
    states: {
      filters,
      setFilters,
      fromTime,
      setFromTime,
      toTime,
      setToTime,
      setIsScreenLoading,
      displayDatepickers,
      setDisplayDatepickers,
    },
    methods: {
      loadData,
    },
  };

  return (
    <Grid container className='kpi-container' spacing={3}>
      <Grid size={12}>
        <h2>Paquetes IPB</h2>
      </Grid>
      <Grid size={{ xs: 12, md: 12, lg: 12, xl: 5 }}>
        <LeadsByCampaingFilters parentProperties={parentProperties} />
        {errorMessage && (
          <Typography pt={2} color='error'>
            {errorMessage}
          </Typography>
        )}
      </Grid>

      <Grid size={2}>
        <button type='button' onClick={loadData} className='m-0 h-55'>
          Buscar
        </button>
      </Grid>

      <Grid size={12}>
        <PackageSalesCharts parentProperties={parentProperties} />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  ipbPackageByChannel: state?.ipbPackageByChannel,
});

const mapDispatchToProps = {
  getIpbPackageByChannelAction,
  cleanIpbPackageByChannelAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageIpbByChannelPage);
